import getConfig from "./config";

const config = getConfig();
const datepickerConfig = {
    onChangeMonthYear: function (year, month) {
        this.dispatchEvent(
            new CustomEvent(config.appName + "/datepickerChangeMonthYear", {
                detail: {
                    year,
                    month,
                },
            }),
        );
    },
    onUpdateDatepicker: function () {
        this.dispatchEvent(
            new CustomEvent(config.appName + "/datepickerUpdated", {
                detail: {
                    datepicker: this,
                },
            }),
        );
    },
    selectOtherMonths: true,
    showOtherMonths: true,
};

const initDatepicker = () => {
    if (config.datepicker) {
        Object.assign(datepickerConfig, config.datepicker);
    }
};

const setupDatepicker = async (datepicker) => {
    await import("jquery-ui/ui/widgets/datepicker");
    window.jQuery(datepicker).datepicker(datepickerConfig);
};

export {initDatepicker, setupDatepicker};
